import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';

import { pageHeaderHeight, pageHeaderHeightMobile } from '../../assets/css/preprocess/global.scss';
import vzMinilogo from '../../assets/images/vz_logo.png';
import { isMobile, getCookie, getSession, getUrlName } from './Helpers';
import SignInLink from './SignInComponent';

const Container = Styled.div`
background: #000000;
height: ${pageHeaderHeightMobile || '68px'};
@media screen and (min-width: 1025px) {
    height: ${pageHeaderHeight || '120px'};;
}
`;
const LogoContainer = Styled.div`
height: 100%;
display: flex;
flex-wrap: wrap;
align-content: center;

img {
    width: 34.2px;
    height: 40px;
}

@media screen and (max-width: 767px) {
    &.stretchContainer {
      padding-left: ${(props) => (props?.isDisplaySignInLink && !isMobile() ? '145px' : '16px')};
    }
}
`;

const PageHeaderFWA = (props) => {
  const pageName = getUrlName(window.location.pathname);
  const isDisplaySignInLink =
    pageName === 'plansOverview' &&
    props.cradleValue !== '' &&
    props.cradleValue?.includes('|signInPlacement|') &&
    getCookie('loggedIn') !== 'true' &&
    getCookie('loggedIn') !== true &&
    getSession('signinfromplans') !== 'Y';

  return (
    <Container>
      <LogoContainer className="stretchContainer" isDisplaySignInLink={isDisplaySignInLink}>
        <img src={vzMinilogo} alt="Verizon logo" />
        {isDisplaySignInLink && <SignInLink />}
      </LogoContainer>
    </Container>
  );
};

PageHeaderFWA.propTypes = {
  cradleValue: PropTypes.string,
};
export default PageHeaderFWA;
